
import { computed, defineComponent, onBeforeMount, Ref } from "vue";
import { Course } from "../../../../domain/entities/entities";
import store from "../../../repository/store/store";
import { dispatchError } from "../../utils/error_handling";
import { useRoute } from "vue-router";
import { ref } from "@vue/runtime-core";
import { EventCourse } from "../../../../domain/entities/courseEvent/courseEvent";
import { ContentProviderType } from "../../../../domain/entities/content-provider/content-provider";

type ContentProviderHelperRoute = { name: string; params: {} } | null;

class ContentProviderHelper {
  type: ContentProviderType;
  title: string;
  label: string;
  route: ContentProviderHelperRoute;

  constructor(
    type = 0,
    title = "",
    label = "",
    route: ContentProviderHelperRoute = null
  ) {
    this.type = type;
    this.title = title;
    this.label = label;
    this.route = route;
  }
}

export default defineComponent({
  name: "ContentHeader",
  setup() {
    const route = useRoute();
    const contentProviderHelper: Ref<ContentProviderHelper> = ref(
      new ContentProviderHelper()
    );

    onBeforeMount(() => loadContentProvider());

    const loadContentProvider = async (): Promise<void> => {
      if (route.params.course_id) {
        await loadCourse();
        loadCourseContentProviderHelper();
      } else {
        await loadEvent();
        loadEventContentProviderHelper();
      }
    };

    const loadCourse = async (): Promise<void> => {
      try {
        await store.dispatch(
          "course_module/loadCourse",
          route.params.course_id
        );
      } catch (e) {
        console.log(e);
        await dispatchError(e);
      }
    };

    const loadCourseContentProviderHelper = (): void => {
      const courseRoute = {
        name: "course",
        params: { course_id: route.params.course_id }
      };

      contentProviderHelper.value = new ContentProviderHelper(
        ContentProviderType.COURSE,
        course.value.title,
        "Treinamento",
        courseRoute
      );
    };

    const loadEvent = async (): Promise<void> => {
      try {
        await store.dispatch("event_module/getEventCourse", {
          eventID: route.params.event_id,
          classID: route.params.class_id
        });
      } catch (e) {
        console.log(e);
        await dispatchError(e);
      }
    };

    const loadEventContentProviderHelper = (): void => {
      const evenRoute = {
        name: "event",
        params: { event_id: route.params.event_id },
        query: { ...route.query }
      };

      contentProviderHelper.value = new ContentProviderHelper(
        ContentProviderType.EVENT,
        event.value.name,
        "Evento",
        evenRoute
      );
    };

    const course = computed(
      (): Course => store.getters["course_module/course"]
    );
    const event = computed(
      (): EventCourse => store.getters["event_module/event"]
    );

    return {
      contentProviderHelper,
      ContentProviderType
    };
  }
});
